import { Component, Input, OnInit } from '@angular/core';
import { ILargeCardInteriorOptions } from '../../interfaces/card-data';

@Component({
    selector: 'scorecards-funded-production-card',
    templateUrl: './scorecards-funded-production-card.component.html',
    styleUrls: ['./scorecards-funded-production-card.component.scss'],
})
export class ScorecardsFundedProductionCardComponent implements OnInit {
    constructor() {}

    @Input() largeCardInteriorOptions: ILargeCardInteriorOptions;

    ngOnInit() {
        //this.largeCardInteriorOptions = {
        //    componentTitle: '',
        //    isDataReady: false,
        //    hasData: false,
        //    showTitle: true,
        //    uniqueId: '',
        //    chartTitleData: null,
        //    accessToUrl: '',
        //};
    }
}
